// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__2qfS_","log":"ModalInventoryLogs_log__1Dp--","date":"ModalInventoryLogs_date__2zM07","userName":"ModalInventoryLogs_userName__3Vv3D"};